import styled from "styled-components";

export const StyledEditorContainer = styled.div`
    height: 70vh;
    display: flex;
    flex-direction: column;

    annotation-editor {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    annotation-editor .mjs-toolbar {
        flex: 0 0 auto;
    }

    annotation-editor .mjs-canvas-container {
        flex: 1 1 auto;
        overflow: auto;
    }

    annotation-editor .mjs-footer {
        flex: 0 0 auto;
    }
`;

export const StyledCenteredBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 48px;
    min-height: 300px;
`;
